import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

import { SET_IMPORT_PAGINATION, SET_IMPORT_FILTERS, GET_IMPORT_RECORDS } from 'import/constants';

const record = new schema.Entity('records');

export const initialState = {
  filters: {
    fulltext: '',
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  needFetch: false,
  isLoading: false,
  entities: { records: {} },
  result: { records: [] },
};

export const reducers = {
  [GET_IMPORT_RECORDS]: {
    [PENDING]: (state) => ({ ...state, isLoading: true, needFetch: false }),
    [FULFILLED]: (state, { payload }) => {
      const pagination = {
        ...state.pagination,
        limit: payload.limit,
        totalPages: payload.totalPages,
        totalDocs: payload.totalDocs,
      };

      const normalized = normalize({ records: payload.records }, { records: [record] });

      return { ...state, isLoading: false, pagination, ...normalized };
    },
    [REJECTED]: (state) => ({ ...state, isLoading: false }),
  },
  [SET_IMPORT_PAGINATION]: (state, { payload }) => ({
    ...state,
    needFetch: true,
    pagination: { ...state.pagination, ...payload },
  }),
  [SET_IMPORT_FILTERS]: (state, { payload }) => ({
    ...state,
    needFetch: true,
    filters: { ...state.filters, ...payload },
  }),
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/reducers/import_list_reducers.js